<template>
  <div class="d-flex jc-center p-t-6">
    <spinner size="100px" v-if="loading"/>
    <div v-else class="container">
      <div
          class="h2 text-bold text-center m-t-3"
          selenium="review-main-header">Review a Pro
      </div>
      <div class="d-flex fd-column ai-center">
        <p class="HEADING p-t-4:mo" selenium="preview-main-header">
          Hi {{ data.firstName }},
        </p>
        <p v-if="alreadyReviewed" class="HEADING m-b-4 p-t-4:mo" selenium="preview-main-header">
          We have already received a review on
          {{ data.profileName }} for your {{ data.subtaskName}} project. Thank you.
        </p>
        <p v-else class="HEADING m-b-4 p-t-4:mo" selenium="preview-main-header">
          Did you hire {{ data.profileName }} for your {{ data.subtaskName}} project?
        </p>
        <pro-avatar :image="data.profileLogo" :size="$device.isMobile ? 102 : 150" class="m-t-6 m-b-6" />
      </div>

      <div v-if="alreadyReviewed" class="MAXWIDTH ">
        <div class=" HIREDORNOT ">
          <router-link
              button
              :to="{name: 'consumer::dashboard'}"
              type="submit"
              class="BUTTON BUTTONFONT btn"
              selenium="return-to-my-requests-button"> Return to My Requests </router-link>
        </div>
      </div>
      <div v-else class="MAXWIDTH ">
        <div class=" HIREDORNOT ">
          <button
              class="BUTTON BUTTONFONT btn"
              @click="onSubmit('yes')"
              selenium="preview-edit">Yes, I Hired this Pro</button>
        </div>
        <div class=" HIREDORNOT">
          <button

              class="BUTTON btn-secondary BUTTONFONT btn-lg:t"
              @click="onSubmit('no')"
              selenium="preview-submit">No, I hired someone else</button>
        </div>
      </div>
    </div>


  </div>
</template>

<script>
import { getReview } from '@homeservices/api-kit/workorder/reviews/';

import reviewParams from '@/mixins/review-params';
import ProAvatar from '@/components/ProAvatar';

export default {
  name: 'hired-not-hired',
  components: {
    ProAvatar,
  },
  mixins: [
    reviewParams,
  ],
  props: {
    data: {
      type: Object,
      default: () => ({}),
    },
  },
  data () {
    return {
      loading: true,
      reviews: null,
    };
  },
  computed: {
    matchingProId () {
      const matchingPro = this.data.workOrder.matches.find(
        match => match.service_provider_user_identifier === this.profileId);
      return matchingPro && matchingPro.service_provider_id;
    },
    alreadyReviewed () {
      return this.reviews && this.reviews.includes(this.matchingProId);
    },

  },
  mounted () {
    setTimeout(() => {
      this.fetchReviews();
    }, 1000);
  },
  methods: {
    async fetchReviews () {
      const { data: { results } } = await getReview({
        order_hashes: this.data.workOrder.order_hash, from: 0,
      });
      this.reviews = results.map(result => result.service_provider_id);
      this.loading = false;
    },
    onSubmit (data) {
      this.$emit('hired-nothired', data);
    },

  },
};
</script>

<style lang="scss" scoped>
  @import "~@homeservices/design-kit/tools";

  $transition-half-duration: 0.15s;

  .HEADING {
    padding: 3*$unit 4*$unit 0;
    font-weight: 600;
    text-align: center;
    max-width: 700px;
    font-size: 24px !important;
    @include tablet {
      @include h3;
    }
  }

  .STAR {
    @include text-small;
    @include margin(0 0.5, 0 3);
    display: flex;
    flex-direction: column;
    width: 50px;
    align-items: center;
    color: $color-gray70;
    transition: font-weight $transition-half-duration;
    &.SELECTED {
      font-weight: 700;
    }
    &.PRESELECTED,
    &.SELECTED  {
      .STAR-ICON {
        color: $color-depot;
      }
    }
    .STAR-ICON {
      @include h4;
      margin-bottom: $unit;
    }
    @include tablet {
      @include h6;
    }
  }

  .COMMENTS {
    border-left: 4px solid lightgray;
  }
  .HIREDORNOT {
     display: flex;
    justify-content: center;
    align-items: center;
  }
  .MAXWIDTH {
    max-width: 700px;
    margin: auto;
  }
  .BUTTONFONT{
    font-size: 22px;
    width: 445px !important;
    height: 60px !important;
        margin: 2*$unit 2*$unit 2*$unit;
    BUTTON {
      flex-basis: 50%;
      margin: $unit;
    }
  }

  .CATEGORIES {
    max-width: 350px;
    margin: auto;
  }

</style>
